// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"SN","backgroundimage":"TN","header":"UN","headerwrap":"VN","title":"WN","promomessage":"XN","upsellItem":"YN","upsellImg":"ZN","helperText":"aO","upsellHeadline":"bO","price":"cO","upsellGross":"eO","upsellNet":"fO","upsellButton":"gO","nutritionfacts":"hO","nutritionimg":"iO","containerwhy":"jO","nutritionwrappwer":"kO","headlinewhy":"lO","boxwhy":"mO","textwhy":"nO","backbutton":"oO","drawercontainer":"pO","logoheader":"qO","textwrap":"rO","timer":"sO"};
    if(module.hot) {
      // 1713996749793
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  